import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../../../services/commande-client/data.service';
import { HeaderService } from '../../../../services/header/header.service';
import { ExportService } from '../../shared/export.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-bon-livraison',
  templateUrl: './bon-livraison.component.html',
  styleUrls: ['./bon-livraison.component.scss']
})
export class BonLivraisonComponent implements OnInit {

    currentStatus: string = 'tous';
    statuses: string[] = ['tous', 'brouillon', 'cree', 'annule', 'livre'];

    /** Compteurs liés aux données : mise à jour automatique à chaque émission (comme commande-client + async pipe). */
    statusCounts$: Observable<Record<string, number>> = this.dataService.bonLivraisonTableData$.pipe(
        startWith(this.dataService.getBonLivraisonTableData() || []),
        map((data: any[]) => this.computeStatusCounts(Array.isArray(data) ? data : []))
    );

    currentUser: any = null;
    userId: number | null = null;
    stationId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.userId = this.currentUser?.id || null;
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        console.log('BonLivraisonComponent initialized');
        this.headerService.setConfig({
            title: 'Bon de Livraison',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        {
                            label: 'PDF',
                            action: () => this.exportService.triggerPDF(),
                            icon: '../../../assets/images/logo/pdf_logo.png'
                        },
                        {
                            label: 'CSV',
                            action: () => this.exportToCSV(),
                            icon: '../../../assets/images/logo/csv_logo.png'
                        }
                    ]
                }
            ]
        });
        // Comme commande-client : uniquement mettre à jour l'onglet actif, pas de chargement ici.
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments.length > 0 ? segments[0].path : 'tous';
            this.currentStatus = path.toLowerCase();
        });
    }

    filterByStatus(status: string) {
        this.currentStatus = status.toLowerCase();
        const mappedStatus = this.mapPathToStatus(status);
        this.dataService.loadByTypeAndStatus('bon-livraison', mappedStatus);
        this.router.navigate([`/vente/bon-livraison/${status.toLowerCase()}`]);
    }


    private mapPathToStatus(path: string): string {
        const statusMap: { [key: string]: string } = {
            tous: 'Tous',
            brouillon: 'Brouillon',
            cree: 'Crée',
            annule: 'Annulé',
            livre: 'Livré'
        };
        return statusMap[path.toLowerCase()] || 'Tous';
    }

    private computeStatusCounts(data: any[]): Record<string, number> {
        const statusKeys = ['Tous', 'Brouillon', 'Crée', 'Annulé', 'Livré'];
        const counts: Record<string, number> = { Tous: data.length };
        statusKeys.filter(s => s !== 'Tous').forEach(s => {
            counts[s] = data.filter((i: any) => (i?.status ?? '') === s).length;
        });
        return counts;
    }

    private exportToCSV(): void {
        const data = this.dataService.getBonLivraisonTableData();
        const headers = ['Référence', 'Client', 'Date', 'Revenu', 'Matricule', 'Statut'];
        const rows = data.map(item => [
            `"${(item.reference || '').replace(/"/g, '""')}"`,
            `"${(item.clientName || '').replace(/"/g, '""')}"`,
            `"${(item.date || '').replace(/"/g, '""')}"`,
            `"${(item.revenue || '').replace(/"/g, '""')}"`,
            `"${(item.matricule || '').replace(/"/g, '""')}"`,
            `"${(item.status || '').replace(/"/g, '""')}"`
        ]);
        const csvContent = headers.join(',') + '\n' + rows.map(row => row.join(',')).join('\n');
        this.exportService.downloadCSV(csvContent, 'bon-livraison.csv');
    }

}
